import React, { useState, useEffect } from "react";
import { Routes, Route, BrowserRouter, Navigate } from "react-router-dom";
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Dashboard from "./views/Dashboard";
import Helpdesk from "./views/Helpdesk";
import Terms from "./views/Terms";
import Login from "./views/Login";
import Logout from "./views/Logout";
import { encStorage } from "./hooks/encStorage";
import axios from "axios";
import { VALIDATE_TOKEN } from "./services/Apis";
import Liquidationrules from "./views/Liquidationrules";
import Marginrules from "./views/Marginrules";
import Refernearn from "./views/Refernearn";
import Myreferrals from "./views/Myreferrals";
import Deposit from "./views/Deposit";
import DepositCreate from "./views/Depositcreate";
import Withdraw from "./views/Withdraw";
import Withdrawcreate from "./views/Withdrawcreate";
import Clientbanks from "./views/Clientbanks";
import Addclientbank from "./views/Addclientbank";
import Referrals from "./views/Referrals";
import CreateCredit from "./views/CreateCredit";
import Downloads from "./views/Downloads";
import CreateRedeemCommission from "./views/CreateRedeemCommission";
import BrokerDashboard from "./views/BrokerDashboard";
import MarketDataTable from "./views/MarketDataTable";

//import DepositCreate from "./views/Depositcreate";

function RequireAuth({ children, redirectTo }) {
  let token = encStorage.getItem("token");
  let isLoggedIn = typeof token != "undefined" ? true : false;
  return isLoggedIn ? children : <Navigate to={redirectTo} />;
}

function LoggedIn({ children, redirectTo }) {
  let token = encStorage.getItem("token");
  let isLoggedIn = typeof token != "undefined" ? true : false;
  return isLoggedIn ? <Navigate to={redirectTo} /> : children;
}

const queryClient = new QueryClient();

const App = () => {
  const [showApi, setshowApi] = useState(false);
  const [isLoggedIn, setisLoggedIn] = useState(false);
  //console.log(encStorage.getItem("token"));
  useEffect(() => {
    const token = encStorage.getItem("token");
    if (typeof token !== "undefined") {
      axios({
        url: VALIDATE_TOKEN,
        method: "POST",
        data: "",
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
        .then(function (response) {
          setisLoggedIn(true);
          setshowApi(true);
        })
        .catch(function (error) {
          setisLoggedIn(false);
          setshowApi(true);
          encStorage.removeItem("client_code");
          encStorage.removeItem("name");
          encStorage.removeItem("token");
        });
    } else {
      setshowApi(true);
    }
  }, []);

  if (!showApi) {
    return <div>Loading...</div>;
  }

  return (
    <>
      <BrowserRouter basename={"/"}>
        <Routes>
          <Route
            path="/"
            element={
              <RequireAuth redirectTo="/login">
                <Dashboard />
              </RequireAuth>
            }
          />
          <Route
            path="/login"
            element={
              <LoggedIn redirectTo="/dashboard">
                <Login />
              </LoggedIn>
            }
          />
          <Route
            path="/logout"
            element={
              <RequireAuth redirectTo="/login">
                <Logout />
              </RequireAuth>
            }
          />
          <Route
            path="/dashboard"
            element={
              <RequireAuth redirectTo="/login">
                <Dashboard />
              </RequireAuth>
            }
          />
          <Route
            path="/helpdesk"
            element={
              <RequireAuth redirectTo="/login">
                <Helpdesk />
              </RequireAuth>
            }
          />
          <Route
            path="/terms-and-conditions"
            element={
              <RequireAuth redirectTo="/login">
                <Terms />
              </RequireAuth>
            }
          />
          <Route
            path="/liquidation-rules"
            element={
              <RequireAuth redirectTo="/login">
                <Liquidationrules />
              </RequireAuth>
            }
          />
          <Route
            path="/margin-rules"
            element={
              <RequireAuth redirectTo="/login">
                <Marginrules />
              </RequireAuth>
            }
          />
          <Route
            path="/refer-to-earn"
            element={
              <RequireAuth redirectTo="/login">
                <Refernearn />
              </RequireAuth>
            }
          />
          <Route
            path="/deposits"
            element={
              <RequireAuth redirectTo="/login">
                <Deposit />
              </RequireAuth>
            }
          />
          <Route
            path="/deposit/create"
            element={
              <RequireAuth redirectTo="/login">
                <DepositCreate />
              </RequireAuth>
            }
          />
          <Route
            path="/withdrawals"
            element={
              <RequireAuth redirectTo="/login">
                <Withdraw />
              </RequireAuth>
            }
          />
          <Route
            path="/withdrawal/create"
            element={
              <RequireAuth redirectTo="/login">
                <Withdrawcreate />
              </RequireAuth>
            }
          />
          <Route
            path="/my-banks"
            element={
              <RequireAuth redirectTo="/login">
                <Clientbanks />
              </RequireAuth>
            }
          />
          <Route
            path="/my-banks/create"
            element={
              <RequireAuth redirectTo="/login">
                <Addclientbank />
              </RequireAuth>
            }
          />
          <Route
            path="/referrals"
            element={
              <RequireAuth redirectTo="/login">
                <Referrals />
              </RequireAuth>
            }
          />
          <Route
            path="/redeem-credit"
            element={
              <RequireAuth redirectTo="/login">
                <CreateCredit />
              </RequireAuth>
            }
          />
          <Route
            path="/redeem-commission"
            element={
              <RequireAuth redirectTo="/login">
                <CreateRedeemCommission />
              </RequireAuth>
            }
          />
          <Route
            path="/downloads"
            element={
              <RequireAuth redirectTo="/login">
                <Downloads />
              </RequireAuth>
            }
          />
          <Route
            path="/broker-dashboard"
            element={
              <RequireAuth redirectTo="/login">
                <BrokerDashboard />
              </RequireAuth>
            }
          />
          <Route
            path="/market-watch"
            element={
              <RequireAuth redirectTo="/login">
                <QueryClientProvider client={queryClient}>
                  <MarketDataTable />
                </QueryClientProvider>
              </RequireAuth>
            }
          />
        </Routes>
      </BrowserRouter>
      <ToastContainer
        position="bottom-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
    </>
  );
};

export default App;
